import { render, staticRenderFns } from "./areaSelect.vue?vue&type=template&id=80c02d36&scoped=true"
import script from "./areaSelect.vue?vue&type=script&lang=js"
export * from "./areaSelect.vue?vue&type=script&lang=js"
import style0 from "./areaSelect.vue?vue&type=style&index=0&id=80c02d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c02d36",
  null
  
)

export default component.exports